import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AgentTracingDetails from "./AgentTracingDetails";

import "./BrainDialog.css";

const BrainDialog = ({
  question,
  usage,
  handleClose,
  open,
  totalInputTokens,
  totalOutputTokens,
  runningTraces,
}) => {
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("lg");

  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Usage Tokens and Tracing Details</DialogTitle>
      <DialogContent>
        <Box sx={{ pb: 2 }}>
          <Typography
            color="primary"
            variant="subtitle1"
            sx={{ fontWeight: "bold" }}
            gutterBottom
          >
            Question
          </Typography>
          {question}
        </Box>

        <Box sx={{ pb: 2 }}>
          <Typography
            color="primary"
            variant="subtitle1"
            sx={{ fontWeight: "bold" }}
            gutterBottom
          >
            Agent Usage Tokens - Claude 3.5 Haiku
          </Typography>

          <TableContainer sx={{ background: "none", width: "100%" }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ p: 1, pr: 2, m: 0 }}>Invocations</TableCell>
                  <TableCell sx={{ p: 1, pr: 2, m: 0 }} align="right">
                    Input Tokens
                  </TableCell>
                  <TableCell sx={{ p: 1, pr: 2, m: 0 }} align="right">
                    Output Tokens
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {usage.map((row, index) => (
                  <TableRow
                    key={"u" + index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell
                      sx={{ p: 1, pr: 2, m: 0 }}
                      align="center"
                      component="th"
                      scope="row"
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ p: 1, pr: 2, m: 0 }} align="right">
                      {row.inputTokens}
                    </TableCell>
                    <TableCell sx={{ p: 1, pr: 2, m: 0 }} align="right">
                      {row.outputTokens}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow
                  key="usage-total"
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    sx={{ p: 1, pr: 2, m: 0 }}
                    component="th"
                    scope="row"
                  >
                    <strong>Total Tokens</strong>
                  </TableCell>
                  <TableCell sx={{ p: 1, pr: 2, m: 0 }} align="right">
                    <strong>{totalInputTokens}</strong>
                  </TableCell>
                  <TableCell sx={{ p: 1, pr: 2, m: 0 }} align="right">
                    <strong>{totalOutputTokens}</strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box>
          <Typography
            color="primary"
            variant="subtitle1"
            sx={{ fontWeight: "bold" }}
            gutterBottom
          >
            Agent Tracing Details
          </Typography>

          <AgentTracingDetails tracingData={runningTraces} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrainDialog;
